import { render, staticRenderFns } from "./SearchIAResultComponent.vue?vue&type=template&id=66743942&scoped=true"
import script from "./SearchIAResultComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchIAResultComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchIAResultComponent.vue?vue&type=style&index=0&id=66743942&lang=scss&scoped=true"
import style1 from "./SearchIAResultComponent.vue?vue&type=style&index=1&id=66743942&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66743942",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66743942')) {
      api.createRecord('66743942', component.options)
    } else {
      api.reload('66743942', component.options)
    }
    module.hot.accept("./SearchIAResultComponent.vue?vue&type=template&id=66743942&scoped=true", function () {
      api.rerender('66743942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documentSearcher/components/SearchAdvanceIA/components/SearchIAResultComponent.vue"
export default component.exports